import type {
  SetStateAction,
  Dispatch,
  CSSProperties,
  FC,
  ReactNode,
} from 'react'
import { PropsGetterArgs } from 'react-popper-tooltip/dist/types'
import { Wrapper, Arrow } from './_styles'

interface TooltipProps {
  maxWidth?: string
  visible?: boolean
  whiteSpace?: string
}

type TooltipGenerator = (
  children: ReactNode,
  tooltipProps?: TooltipProps
) => FC<{
  tooltipRef: Dispatch<SetStateAction<HTMLElement | null>>
  getArrowProps: (args?: PropsGetterArgs) => {
    style: CSSProperties
    'data-popper-arrow': boolean
  }
  getTooltipProps: (args?: PropsGetterArgs) => {
    'data-popper-interactive': boolean | undefined
    style: CSSProperties
  }
}>

const defaultProps: TooltipProps = {
  maxWidth: 'none',
  visible: undefined,
  whiteSpace: 'normal',
}

const Tooltip: TooltipGenerator =
  (children, tooltipProps = defaultProps) =>
  props => {
    const { tooltipRef, getArrowProps, getTooltipProps } = props
    const { maxWidth, visible, whiteSpace } = tooltipProps

    return (
      <Wrapper
        ref={tooltipRef}
        {...getTooltipProps()}
        $maxWidth={maxWidth}
        $visible={visible}
        $whiteSpace={whiteSpace}
      >
        {children}
        <Arrow {...getArrowProps()} />
      </Wrapper>
    )
  }

export default Tooltip
